// @ts-nocheck
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles, Box } from '@material-ui/core';
import { useAlert, useIfMounted, useOnUnmount } from '../../../common/hooks';
import { AlertSeverity } from '../../../common/providers';
import { LoadingWrapper, Panel } from '../../../common/components';
import { selectVoucherDetails } from '../state/voucherSelectors';
import { deselectVoucher, fetchVoucher } from '../state/voucherActions';
import VoucherSearch from './partials/VoucherSearch';
import VoucherDetails from './partials/VoucherDetails';
import VoucherService from '../services/VoucherService';

const useStyles = makeStyles(theme => ({
  root: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
  },
  details: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    '& > *:first-child': {
      marginTop: theme.spacing(3),
    },
  },
}));

function VouchersPage() {
  const [loading, setLoading] = useState(false);
  const [t] = useTranslation();
  const { showAlert } = useAlert();
  const voucherDetails = useSelector(selectVoucherDetails);
  const classes = useStyles();
  const ifMounted = useIfMounted();
  const dispatch = useDispatch();

  useOnUnmount(() => {
    if (voucherDetails) {
      dispatch(deselectVoucher());
    }
  });

  const handleFetchVoucher = useCallback(
    async voucherNo => {
      try {
        setLoading(true);
        await dispatch(fetchVoucher(voucherNo));
      } catch (e) {
        showAlert({
          title: t('voucher.voucherFetchError'),
          message: e.message,
          severity: AlertSeverity.Error,
        });
      } finally {
        ifMounted(() => setLoading(false));
      }
    },
    [dispatch, ifMounted, showAlert, t]
  );

  const handleDownloadVouchers = async campaignSeriesId => {
    window.location.href = VoucherService.downloadMultiVouchers(campaignSeriesId);
    _.delay(() => {
      showAlert({
        title: t('common.success'),
        message: t('campaign.campaignSeriesDownloadVouchersSuccess'),
        severity: AlertSeverity.Success,
      });
    }, 500);
  };

  return (
    <Box id="Vouchers-container" className={classes.root}>
      <Panel id="Vouchers-search" title={t('voucher.voucherSearchTitle')}>
        <VoucherSearch onFetchVoucher={handleFetchVoucher} />
      </Panel>
      <Box className={classes.details}>
        <LoadingWrapper loading={loading}>
          {voucherDetails && (
            <Panel id="Vouchers-details" variant="contained">
              <VoucherDetails
                voucher={voucherDetails}
                onDownloadVouchers={handleDownloadVouchers}
              />
            </Panel>
          )}
        </LoadingWrapper>
      </Box>
    </Box>
  );
}

export default VouchersPage;
